import { StateSchema } from 'app/config/storeConfig/types';
import { User } from 'entities/User';

export const getSelectedUser = (state: StateSchema): Nullable<User> => state.createContractModal.selectedUser;
